import styled from "styled-components/macro";

export const TooltipContainer = styled.div(({ theme }) => ({
  cursor: "default",
  position: "relative",

  svg: {
    color: theme.color.brandPrimary.light,
  },
}));

export const Tooltip = styled.div(({ theme, show }) => ({
  padding: "16px",
  visibility: show ? "visible" : "hidden",
  backgroundColor: theme.color.brandPrimary.light,
  borderRadius: theme.border.radius["2xs"],
  position: "absolute",
  zIndex: 5,
  maxWidth: "calc(100vw - 32px)",
}));

export const Header = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  color: theme.color.neutral["08"],
  paddingBottom: "16px",
  borderBottom: `1px solid ${theme.color.line.medium}`,

  svg: {
    width: "20px",
    height: "20px",
    fill: theme.color.neutral["08"],
    cursor: "pointer",
  },
}));

export const Content = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "18px",
  color: theme.color.neutral["08"],
  marginTop: "16px",
  lineHeight: "150%",
  textAlign: "left",

  "> span": {
    fontWeight: 500,
  },
}));
